// ══════════════════════════════════════════════════════════════════════════════════════════════
//  CARGAR EL DICCIONARIO DE UN IDIOMA (B-2259, t523, 27-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  Cada idioma es una carpeta, shared/i18n/<idioma>/, con un JSON por zona (shared/i18n/zonas.json). Vite los parte en
//  trozos que se bajan SOLO cuando hacen falta (utils/i18nDiccionarios, generado): quien trabaja en castellano no se baja
//  ninguno. La pantalla del paciente pide solo sus zonas («vocabulario», «comun», «paciente»); la aplicación del equipo, todas.
//
//  Sin import.meta y sin React: lo cargan de verdad las guardias (test-helpers/utilDelFrontend).
//
//  LO QUE SE RECUERDA EN ESTE DISPOSITIVO (localStorage, por dominio): el último idioma de la sesión, para pintar la
//  primera pantalla ya en ese idioma al volver (main.jsx · prepararIdiomaGuardado). Sin nada guardado, o en castellano,
//  la aplicación arranca exactamente como siempre: sin esperar a nada.
import { ponerIdioma, datosIdioma, idiomaActivo } from './i18n.js'
import { DICCIONARIOS } from './i18nDiccionarios.js'

export const ZONAS_PACIENTE = Object.freeze(['vocabulario', 'comun', 'paciente'])
export const ZONAS_EXTERNOS = Object.freeze(['vocabulario', 'comun', 'paciente', 'externos'])

/** Las claves del índice («en/paciente»...) de ese idioma (y de esas zonas, si se dicen). */
export function diccionariosDe(idioma, zonas = null, indice = DICCIONARIOS) {
  return Object.keys(indice || {}).filter((k) => k.split('/')[0] === idioma && (!zonas || zonas.includes(k.split('/')[1]))).sort()
}

/** Carga el idioma y lo pone. Castellano, o un idioma que no está en el catálogo: castellano, sin bajar nada. */
export async function cargarIdioma(idioma, { zonas = null, indice = DICCIONARIOS } = {}) {
  if (!idioma || idioma === 'es' || !datosIdioma(idioma)) { ponerIdioma('es'); return 'es' }
  const claves = diccionariosDe(idioma, zonas, indice)
  const mods = await Promise.all(claves.map((k) => Promise.resolve().then(() => indice[k]()).catch(() => null)))
  ponerIdioma(idioma, mods.filter(Boolean).map((m) => (m && m.default) || m))
  return idiomaActivo()
}

const CLAVE = () => 'biango-idioma:' + (typeof location !== 'undefined' ? location.host : 'app')

export function recordarIdioma(idioma) {
  try {
    if (!idioma || idioma === 'es') localStorage.removeItem(CLAVE())
    else localStorage.setItem(CLAVE(), idioma)
  } catch (_) { /* sin almacenamiento: no se recuerda */ }
}

export function idiomaRecordado() {
  try { return localStorage.getItem(CLAVE()) || null } catch (_) { return null }
}

/**
 * Para main.jsx, ANTES de pintar: si este dispositivo recuerda un idioma que no es el castellano, una promesa que lo carga
 * (con un tope de 1,5 s: si tarda, se pinta en castellano y llega después). Sin nada recordado, null: se pinta YA, como
 * siempre. En las pantallas del paciente no se usa (allí decide utils/i18nPublico con lo que dice el servidor).
 */
export function prepararIdiomaGuardado() {
  const idioma = idiomaRecordado()
  if (!idioma || idioma === 'es' || !datosIdioma(idioma)) return null
  const tope = new Promise((resolve) => setTimeout(resolve, 1500))
  return Promise.race([cargarIdioma(idioma).catch(() => null), tope])
}
